module.exports = __webpack_public_path__ + "v1.2.5.20250227/img/015.a074ee9a.png";